export default "__VITE_ASSET__EwvO58yA__"